import { FC } from "react";
import { useStore } from "@ludens-reklame/rubics-v3-react/store/hooks";
import { Signature } from "../../types/dataBuckets.js";

interface Props {
  title?: string;
  col?: "two" | "three";
}

const CompanyList: FC<Props> = ({ title, col = "three" }) => {
  const store = useStore<{}, { signatures: Signature[] }>();

  if (!store.context.dataBuckets.signatures) {
    return null;
  }

  const sortedSignatures = store.context.dataBuckets.signatures.sort((a, b) =>
    a.name.localeCompare(b.name)
  );

  return (
    <div className="company-list">
      <div className="mw-small">
        <div className="title">{title && <h2>{title}</h2>}</div>
        <div className={`companies ${col}`}>
          {sortedSignatures.map((signature, i) => (
            <h4 key={i}>{signature.name}</h4>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CompanyList;
